import { getActivePinia } from 'pinia'

import { useCoreStore } from '@/core/store'
import { Validators } from '@/forms'

export const SUGARFISH_BRAND_ID = 'EMfXhIh5xeb6'

interface ValidationResult {
  errors: string[]
  valid: boolean
}

type Validator = (value: unknown) => ValidationResult

const validResult = (): ValidationResult => ({ errors: [], valid: true })

const isSugarfishActive = (): boolean => {
  const pinia = getActivePinia()

  return pinia
    ? useCoreStore(pinia).activeBrandId === SUGARFISH_BRAND_ID
    : false
}

const bypassForSugarfish =
  (validator: Validator): Validator =>
  (value) =>
    isSugarfishActive() ? validResult() : validator(value)

export const websiteSectionRequired = bypassForSugarfish(Validators.required)

export const websiteSectionRequiredValue = (value: unknown): boolean =>
  websiteSectionRequired(value).valid

export const websiteSectionMaxLength = (maxLength: number): Validator =>
  bypassForSugarfish(Validators.maxLength(maxLength))

export const websiteSectionMaxChars = (maxLength: number): number | undefined =>
  isSugarfishActive() ? undefined : maxLength

export const WebsiteSectionValidators = {
  maxLength: websiteSectionMaxLength,
  required: websiteSectionRequired,
}
